import React from "react";
import Chatbox from "../../components/chatbox/Chatbox";
import "./Home.scss";

const Home = () => {
  return (
    <div className="home">
      <Chatbox />
    </div>
  );
};

export default Home;
